import { createClient } from "@supabase/supabase-js"

const supabaseUrl = "https://ormokkgdgbhcpogwsicj.supabase.co"
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9ybW9ra2dkZ2JoY3BvZ3dzaWNqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM0NjkwMzMsImV4cCI6MjA2OTA0NTAzM30.qsJi4ZS4PyNefO6kqaocxxdB0IZEOhr70DENCdrtOd0"

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Database schema types (for better TypeScript support)
export const TABLES = {
  USERS: "users",
  USER_PREFERENCES: "user_preferences",
  RECOMMENDATION_SESSIONS: "recommendation_sessions",
  PURCHASE_HISTORY: "purchase_history",
}

// Auth helper functions
export const auth = {
  // Sign up with email and password
  signUp: async (email, password, userData = {}) => {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: userData, // Additional user metadata
      },
    })
    return { data, error }
  },

  // Sign in with email and password
  signIn: async (email, password) => {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    })
    return { data, error }
  },

  // Sign out
  signOut: async () => {
    const { error } = await supabase.auth.signOut()
    return { error }
  },

  // Get current user
  getUser: async () => {
    const {
      data: { user },
      error,
    } = await supabase.auth.getUser()
    return { user, error }
  },

  // Get current session
  getSession: async () => {
    const {
      data: { session },
      error,
    } = await supabase.auth.getSession()
    return { session, error }
  },

  // Listen to auth changes
  onAuthStateChange: callback => {
    return supabase.auth.onAuthStateChange(callback)
  },
}

// Database helper functions
export const db = {
  // Generic select
  select: (table, columns = "*") => {
    return supabase.from(table).select(columns)
  },

  // Generic insert
  insert: (table, data) => {
    return supabase.from(table).insert(data)
  },

  // Generic update
  update: (table, data) => {
    return supabase.from(table).update(data)
  },

  // Generic delete
  delete: table => {
    return supabase.from(table).delete()
  },
}
